export const Visualizacion = ({ name, value, onChange }) => {
    return (
        <select name={name} value={value} onChange={onChange}>
            <option value='0'>Seleccionar...</option>
            <option value='1'>Detalle</option>
            <option value='2'>Gráfica</option>
        </select>
    )
}